import IntegerInput from "./IntegerInput";

export default IntegerInput;
